import { useTranslations } from "@/lib/static-intl";

const AuthorTag = () => {
  const explorePostDetailsT = useTranslations("explore.explore_post_details");
  return (
    <span className="text-[11px] bg-gray-100 dark:bg-dark_bg_grey text-[rgba(51,51,51,0.6)] dark:text-dark_secondary_label px-1 py-0.5 h-fit w-fit font-medium rounded-md">
      {explorePostDetailsT("author")}
    </span>
  );
};

export default AuthorTag;
